export default async function sendQuery<T = unknown>(
    query: URLSearchParams
): Promise<T> {
    const res = await fetch(`/game-strategy-explorer?${query.toString()}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    })

    if (!res.ok) {
        throw new Error('Failed to fetch leverage index')
    }

    return res.json()
}
